module.exports = __webpack_public_path__ + "img/fream.cffb1d39.png";